// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2pPAZ","question":"styles_question__2uLoV","description":"styles_description__23A_t"};